import React from 'react';
import './Footer.css';
import assetUrl from '../../../utils/assetUrl';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-left">
          <div className="footer-branding">
            {/* Logo placeholder - replace with actual SVG or Image if available */}
            <span className="brand-icon"><img src={assetUrl('/img/logo_white.png')} alt="Myft Hair Studio" /></span>
            <span className="brand-name">MYFT HAIR STUDIO</span>
          </div>

          <p className="footer-description">
            Εξειδικευμένες υπηρεσίες περιποίησης για άνδρες και γυναίκες,
            αναδεικνύοντας το προσωπικό σας στυλ με επαγγελματισμό.
          </p>
          <div className="footer-socials">
            {/* Social Icons using text/emoji for simplicity mostly, can be replaced by SVGs */}
            <a href="https://www.instagram.com/myft_hair_studio" className="social-icon"><i className="fab fa-instagram"></i></a>
          </div>

          <button className="back-to-top-btn" onClick={scrollToTop}>
            <span className="arrow-up">^</span> ΠΙΣΩ ΣΤΗΝ ΑΡΧΗ
          </button>
        </div>

        <div className="footer-right">
          <div className="footer-nav-column">
            <h4>Site Map</h4>
            <ul>
              <li><a href="/">Αρχική</a></li>
              <li><a href="/men">Ανδρικό</a></li>
              <li><a href="/women">Γυναικείο</a></li>
              <li><a href="/products">Προϊόντα</a></li>
              <li><a href="/login">Σύνδεση</a></li>
            </ul>
          </div>

          {/* <div className="footer-nav-column">
            <h4>Legal</h4>
            <ul>
              <li><a href="/privacy">Πολιτική Απορρήτου</a></li>
              <li><a href="#terms">Όροι Υπηρεσίας</a></li>
            </ul>
          </div> */}
        </div>
      </div>

      <div className="footer-bottom">
        <p>Copyright © 2026, Myft Hair Studio, All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
